module.exports = __webpack_public_path__ + "stylesheets/main_8cc6c061346d11a169023c147b4e24bb.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/main.less
// module id = 3ksy
// module chunks = 153